import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Creates QR code using qr-code-styling.
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Values
 * -------
 *
 * content   - (required) - QR code content
 * size      - (optional) - size of QR code
 * className - (optional) - class name to add to the QR code
 *
 * Usage
 * -------
 *
 * <div
 *   data-controller="qr-code"
 *   data-qr-code-content-value="content"
 *   data-qr-code-size-value="320"
 *   data-qr-code-class-name-value="class-name"
 * ></div>
 */
export class QrCode extends Controller {
    static values = {
        content: String,
        size: { type: Number, default: 400 },
        className: String,
    };
    async connect() {
        const { default: QRCodeStyling } = await import('qr-code-styling');
        const qrCode = new QRCodeStyling({
            width: this.sizeValue,
            height: this.sizeValue,
            type: 'svg',
            data: this.contentValue,
            cornersSquareOptions: { type: 'square' },
            dotsOptions: { type: 'square' },
        });
        qrCode.append(this.element);
        this.element.firstElementChild?.setAttribute('data-turbo-temporary', 'true');
        this.element.firstElementChild?.setAttribute('width', '100%');
        this.element.firstElementChild?.setAttribute('height', 'auto');
        this.element.firstElementChild?.setAttribute('style', `max-width:${this.sizeValue}px;`);
        if (this.hasClassNameValue) {
            this.element.firstElementChild?.classList.add(this.classNameValue);
        }
    }
}
